import React from "react";
const About = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-white py-12 px-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold mb-8 text-center">About Our Movie Website</h1>
        <p className="text-lg leading-relaxed mb-6">
          Welcome to our movie website! We are passionate about delivering a seamless and enjoyable
          user experience for movie enthusiasts. Our platform is a frontend-driven application that
          focuses on providing a modern and visually appealing user interface. Whether you're looking
          for the most popular movies or top-rated films, our site makes it easy to find exactly what
          you're looking for.
        </p>
        <p className="text-lg leading-relaxed mb-6">
          Our website allows you to effortlessly browse through a vast collection of movies and sort
          them based on popularity or ratings. The intuitive design and smooth functionality ensure that
          you can explore and discover movies with ease. We are committed to enhancing your movie browsing
          experience with up-to-date content and a user-friendly interface.
        </p>
        <p className="text-lg leading-relaxed">
          We hope you enjoy using our site as much as we enjoyed creating it. If you have any feedback
          or suggestions, feel free to reach out to us. Happy movie browsing!
        </p>
      </div>
    </div>
  );
};

export default About;
